export default __webpack_public_path__ + "static/media/menu_01.5aa87010.jpg";